import React, { forwardRef } from 'react';
import IBuildrProps from 'src/utilities/IBuildrProps';
import classNames from 'classnames';

interface IRelatedQuestionsProps extends IBuildrProps {
    children;
}

const RelatedQuestions = forwardRef((props: IRelatedQuestionsProps, ref: any) => {
    return (
        <div data-id={props.cmsId} ref={ref} className={classNames(props.editorClassObj, props.className)}>
            <div className="mb-5">
                <div className="text-serif h4 text-primary">Related Questions:</div>
                <ul>
                    {props.children}
                </ul>
            </div>
        </div>
    )
});

export default RelatedQuestions;